<template>
    <!-- 文本类型 -->
    <el-input
        v-if="item.type === 'text' || item.type === 'textarea'"
        :type="item.type === 'textarea' ? 'textarea' : ''"
        v-model="item.value"
        :maxlength="item.property?.length"
        :placeholder="$attrs.placeholder || $t('common.请输入')"
        v-bind="$attrs"
        v-on="$listeners"
        show-word-limit
    ></el-input>
    <!-- 数字类型 -->
    <el-input-number
        v-else-if="item.type === 'number'"
        class="Number_input_text_left"
        style="width: 100%;"
        v-model="item.value"
        :maxlength="item.property?.length"
        :controls="$attrs.controls || false"
        :placeholder="$attrs.placeholder || $t('common.请输入')"
        v-bind="$attrs"
        v-on="$listeners"
    ></el-input-number>
    <!-- 年类型 -->
    <el-date-picker
        v-else-if="item.type === 'year'"
        class="blue_icon"
        style="width: 100%;"
        type="year"
        format="yyyy"
        value-format="yyyy"
        v-model="item.value"
        :placeholder="$attrs.placeholder || $t('common.请选择')"
        v-bind="$attrs"
        v-on="$listeners"
    ></el-date-picker>
    <!-- 日期类型 -->
    <el-date-picker
        v-else-if="item.type === 'date'"
        class="blue_icon"
        style="width: 100%;"
        type="date"
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
        v-model="item.value"
        :placeholder="$attrs.placeholder || $t('common.请选择')"
        v-bind="$attrs"
        v-on="$listeners"
    ></el-date-picker>
    <!-- 下拉框类型 -->
    <cl-el-select
        v-else-if="item.type === 'select' || item.type === 'dict'"
        style="width: 100%;"
        :options="item.property.data"
        :option="item.option ? item.option : {
			label: 'name',
			value: 'key',
		}"
        :dict="item.type === 'dict' ? item.property.dictCode : ''"
        :multiple="item.property.multi"
        v-model="item.value"
        :placeholder="$attrs.placeholder || $t('common.请选择')"
        v-bind="$attrs"
        v-on="$listeners"
    ></cl-el-select>
    <!-- 文件类型 -->
    <div v-else-if="item.type === 'file'" class="file_wrapper">
        <cl-file-list v-model="item.value" :customizeDownLoad="true" @downFile="downFile">
            <template #file-add>
                <el-upload
                    v-show="item.property.multi || (!item.property.multi && item.value.length <= 0)"
                    class="upload-demo"
                    action="#"
                    :show-file-list="false"
                    :http-request="beforeUpload"
                >
                    <div class="upload">
                        <i class="el-icon-plus"></i>
                    </div>
                </el-upload>
            </template>
        </cl-file-list>
    </div>
</template>

<script>
/**
 * ComponentName: cl-dynamic-field
 * Author: zhangjun
 * 组件说明：渲染模板用的动态Field组件。
 * eg: <cl-dynamic-field :item="item"></cl-dynamic-field>
 */
export default {
    name: 'cl-dynamic-field',
    props: {
        item: {
            type: Object,
            default: () => ({ style: 'text' }),
        },
    },
    data () {
        return {
            description: '动态表单组件',
        }
    },
    methods: {
        // 下载
        async downFile (row) {
            const res = await this.$server.getBolbByOssUrl(row.url)
            this.$utils.downloadByAlabel(res, row.name)
        },
        // 上传前验证
        beforeUpload (files) {
            console.log('files', files);
            const { file } = files
            const isLt5M = file.size / 1024 / 1024 < 50;
            if (!isLt5M) {
                this.$message.error(this.$t('message.文件大小不能超过50M'));
                return
            }
            this.uploadFiles(file)
        },
        // 上传文件方法
        async uploadFiles (file) {
            const formData = new FormData();
            formData.append('file', file);
            const { code, data } = await this.$server.uploadFile(formData)
            if (code === 200) {
                const obj = {
                    name: file.name,
                    url: data
                }
                this.item.value.push(obj)
                // console.log('this.item',this.item);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.file_wrapper {
    ::v-deep .file_item {
        padding: 5px 0;
        border: none;
    }
    .upload {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px dashed #c1d6ee;
        border-radius: 2px;
        text-align: center;
        .el-icon-plus {
            font-weight: bold;
            color: #3663e1;
        }
    }
}
</style>